import { connect } from 'react-redux';
import { get } from 'lodash';
// component
import LoadingManager from './loading-manager.component';

import {
    ILoadingManagerStoreProps
} from 'modules/loading-manager/loading-manager.types';

const mapStateToProps = (state: Object): ILoadingManagerStoreProps => ({
    loading: get(state, 'loadingManager.loading')
});

export default connect<ILoadingManagerStoreProps>(
    mapStateToProps,
)(LoadingManager);
